export default ngModule => {
  ngModule.controller('ComparatorRetentionCtrl', function (AonConfig, $state, application, AonApplicationService, AonApi, ZohoService) {
    this.formChoices = AonConfig.formChoices;
    this.corporate = AonConfig.corporate;
    this.deployment = AonConfig.deployment;
    this.application = application;
    this.product = AonApplicationService.product.selectedPrice;
    this.fund_email = _.get(this.product, "fund.email", "");
    const lead_id = _.get(this.application, 'zoho_id', false);
    this.resultMessage = null;

    this.emailValidatorPattern = {
      required: true,
      pattern: "[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*",
      error_messages: {
        pattern: 'Please provide a valid email address',
      },
    };

    this.mobileValidatorPattern = {
      required: true,
      pattern: '^04[0-9]{8}$',
      error_messages: {
        pattern: 'Please provide a valid mobile phone number',
      },
    };

    const d = new Date();
    this.email_data = {
      note_title: [d.getDate(), d.getMonth()+1, d.getFullYear()].join("/") + " " + d.toTimeString().split(" ")[0]
    }

    this.submit = () => {
      const form = this.retentionForm;

      if (!lead_id) {
        return;
      }

      if (!form.$valid) {
        form.focusInvalid();
        return;
      }

      this.resultMessage = null;
      this.isSaving = true;
      const retention_data = {
        current_product: this.email_data.current_product,
        address: this.email_data.address,
        notes: this.email_data.notes,
        note_title: this.email_data.note_title,
      };
      const onError = (response) => {
        this.isSaving = false;
        if (response.status === 400 && response.data) {
          const nonFormErrors = [];
          Object.keys(response.data).forEach(key => {
            if (form[key]) {
              form[key].setExternalValidation(null, response.data[key]);
            } else {
              nonFormErrors.push(`${key}: ${response.data[key]}`);
            }
          });
          form.focusInvalid();
          if (nonFormErrors.length) {
            this.resultMessage = `There was an error saving this application to Zoho: ${nonFormErrors.join(', ')}`;
          }
        } else {
          const error = response.error;
          this.resultMessage = `There was an error saving this application to Zoho: ${error}`;
        }
      }
      const onSuccess = () => {
        this.isSaving = false;
        this.resultMessage = 'Zoho data successfully submitted.';
      }
      ZohoService.sendRetentionToZoho(lead_id, retention_data, this.application, this.product).then(onSuccess, onError);
    };

  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/retention-ctrl.js